import { Route } from 'react-router-dom';

import { SubscriptionTabsEnum } from '../../constants';
import { SubscriptionWizardActivity } from './SubscriptionWizard.activity';

const TAB_PREFIX = 'subscription';

export const getSubscriptionPlansUrl = () => `/${TAB_PREFIX}/${SubscriptionTabsEnum.Plans}`;
export const getSubscriptionCheckoutUrl = () => `/${TAB_PREFIX}/${SubscriptionTabsEnum.Checkout}`;

export const SubscriptionPlansRoute = () => (
  <Route path={`/${TAB_PREFIX}/*`} element={<SubscriptionWizardActivity />} />
);
